export default "__VITE_ASSET__CmPkWa6i__"